import { Locale } from '@/enumerations/Locale';

export const setLocaleToLS = (locale: Locale) => {
  localStorage.setItem('locale', locale);
};

export const getLocaleFromLS = () => {
  return localStorage.getItem('locale')! || '';
};
